import { cn } from "@/libs/utils";
import { CurrencyIsoCode } from "@/models/GameResell";
import { OrderItemV2 } from "@/models/orders/OrderDraft";
import { useProducts } from "@/services/product/useProductService";
import { ProductUtil } from "@/utils/ProductUtil";
import { useTrans } from "@/utils/useTrans";
import { OrderSummaryItem } from "@/v2-components/pages/checkout/order-summary-item";
import { NotifyMe } from "@/v2-components/pages/tactsuit/NotifyMe";

export function OrderSummaryDeviceItems({
  items,
  currency,
  countryCode,
  header,
}: {
  header?: string;
  items: OrderItemV2[];
  currency: CurrencyIsoCode;
  countryCode: string;
}) {
  const products = useProducts();

  return (
    <section className="space-y-4">
      {!!header && <h2 className="text-lg font-400">{header}</h2>}
      <ul>
        {items.map((item) => {
          const product = ProductUtil.getProductBySku(
            products?.data || [],
            item.sku,
          );
          let stock = Infinity;
          if (product) {
            stock = ProductUtil.getStockBySku(product, item.sku);
          }

          return (
            <li key={item.sku} className="relative flex justify-between">
              <OrderSummaryItem
                currency={currency}
                countryCode={countryCode}
                item={item}
              />
              {!stock && (
                <UnavailableItem
                  productSku={item.sku}
                  productSlug={item.slug}
                />
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
}

const UnavailableItem = ({
  productSlug,
  productSku,
}: {
  productSlug: string;
  productSku?: string;
}) => {
  const { t } = useTrans(["gnb"]);
  return (
    <div className="absolute inset-0 z-10 size-full overflow-hidden">
      <div className="relative flex size-full flex-col items-center justify-center gap-y-3 bg-white/90">
        <p className="text-base font-400 text-black">{t("Unavailable Item")}</p>
        <NotifyMe
          className={cn("px-6 text-white")}
          productSku={productSku}
          productSlug={productSlug}
          variant={"darkgray-fill"}
          title={t("Notify When Available")}
        />
      </div>
    </div>
  );
};
